import * as React from 'react';

export const FacebookIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Facebook"
    >
      <path
        d="M9 0C13.9706 0 18 4.02943 18 9C18 13.4923 14.7088 17.2154 10.4062 17.8906V11.6016H12.5029L12.9023 9H10.4062V7.31152C10.4063 6.59988 10.7552 5.90625 11.873 5.90625H13.0078V3.69141C13.0078 3.69141 11.9779 3.51562 10.9932 3.51562C8.93741 3.51563 7.59375 4.76196 7.59375 7.01758V9H5.30859V11.6016H7.59375V17.8906C3.29116 17.2154 0 13.4921 0 9C0 4.02943 4.02943 0 9 0Z"
        fill="currentColor"
      />
    </svg>
  );
};
